import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/i18n";

function App() {
  return (
    <div className="App bg-[#050505] text-white">
      <I18nProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-right" />
      </I18nProvider>
    </div>
  );
}

export default App;
